import React, { useState, useEffect } from 'react';
import { publicAPI } from '../util/api'; // Импортируем API для запросов
import { useNavigate, useLocation } from 'react-router-dom'; // Для перенаправления и получения данных

const Verify = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate(); // Для перенаправления
  const location = useLocation(); // Для получения данных о состоянии (например, ошибка)

  useEffect(() => {
    // Проверяем наличие refresh_token при загрузке страницы
    const refreshToken = localStorage.getItem('refresh_token');
    if (refreshToken) {
      // Если есть refresh_token, перенаправляем на страницу Dashboard
      navigate('/dashboard');
    }

    // Если есть ошибка, переданная с другой страницы, отобразим её
    if (location.state && location.state.error) {
      setError(location.state.error);
    }
  }, [navigate, location.state]);

  const handleVerificationRequest = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      const response = await publicAPI.post('/mail/verify', { email });

      if (response.status === 200) {
        setSuccess('Verification link sent! Check your email.');
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setError('No user found with that email. Please check your email or register.');
      } else if (error.response && error.response.status === 400 && error.response.data.detail === "Email is already verified") {
        setError('Your email is already verified. You can now log in.');
      } else {
        setError('Something went wrong. Please try again.');
      }
    }
  };

  return (
    <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          Resend Verification Email
        </h2>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        {/* Если успех - отображаем зеленое сообщение */}
        {success && <p className="text-green-500 mb-4 text-center">{success}</p>}

        {/* Если ошибка - отображаем красное сообщение */}
        {error && <p className="text-red-500 mb-4 text-center">{error}</p>}

        <form onSubmit={handleVerificationRequest} className="space-y-6">
          <div>
            <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
              Email address
            </label>
            <div className="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Send Verification Link
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Verify;